import { EventEmitter } from 'events';
export class LoadingProgress {
    private eventEmitter = new EventEmitter();
    /**
     * The max value the load process should have
     */
    private _max: number = 100;
    public get max(): number {
        return this._max;
    }
    public set max(v: number) {
        this._max = v;
    }
    /**
     * The current value along the loading.
     */
    private _value: number = 0;
    public get value(): number {
        return this._value;
    }
    public set value(v: number) {
        
        if (v > this.max) {
            v = this.max;
        }
        this._value = v;

        if (Math.abs(this.value - this.max) < 0.001)
            this.Complete();
        let emitValue = this.value / this.max;
        if (this._interval) {
            let curr = Math.trunc(emitValue / (this._interval * 0.01));
            if (this._intervalStep < curr) {
                this._intervalStep = curr;
                this.Progress(emitValue)
            }
        }
        else
            this.Progress(emitValue)
    }

    private _completed: boolean = false;;

    /**
     * The current state of loading.
     */
    private _status: string = '';
    public get status(): string {
        return this._status;
    }
    public set status(v: string) {
        this._status = v;
        this.StatusChange(v);
    }

    private _interval: number = 5;
    private _intervalStep = 0;

    public onProgress(listener: (...args: any[]) => void, options?: Partial<{ once: boolean, interval: number }>) {
        if (!listener) {
            this.eventEmitter.removeAllListeners('progress');
            return;
        }
        let { once, interval } = options ?? {};
        if (once)
            this.eventEmitter.once('progress', listener)
        else {
            if (interval)
                this._interval = interval;
            this.eventEmitter.addListener('progress', listener)
        }

    }
    public RemoveOnProgress(listener: (...args: any[]) => void) {
        this.eventEmitter.removeListener('progress', listener);
    }
    public onStatusChange(listener: (...args: any[]) => void, options?: Partial<{ once: boolean }>) {
        if (!listener) {
            this.eventEmitter.removeAllListeners('status');
            return;
        }
        let { once } = options ?? {};
        if (once)
            this.eventEmitter.once('status', listener)
        else
            this.eventEmitter.addListener('status', listener)
    }
    public RemoveOnStatusChange(listener: (...args: any[]) => void) {
        this.eventEmitter.removeListener('status', listener);
    }
    public onComplete(listener: (...args: any[]) => void, options?: Partial<{ once: boolean }>) {
        if (!listener) {
            this.eventEmitter.removeAllListeners('complete');
            return;
        }
        let { once } = options ?? {};
        if (once)
            this.eventEmitter.once('complete', listener)
        else
            this.eventEmitter.addListener('complete', listener)
    }
    public RemoveOnComplete(listener: (...args: any[]) => void) {
        this.eventEmitter.removeListener('complete', listener);
    }
    public onReset(listener: (...args: any[]) => void) {
        if (!listener) {
            this.eventEmitter.removeAllListeners('reset');
            return;
        }
        this.eventEmitter.addListener('reset', listener)
    }
    public RemoveOnReset(listener: (...args: any[]) => void) {
        this.eventEmitter.removeListener('reset', listener);
    }
    public removeListener = this.eventEmitter.removeListener;
    public addListener = this.eventEmitter.addListener;
    public removeAllListeners() {
        this.eventEmitter.removeAllListeners();
    }

    private async Progress(v: number) {
        this.eventEmitter.emit('progress', v);
    }
    private async StatusChange(s: string) {
        this.eventEmitter.emit('status', s);
    }
    private async Complete() {
        if (this._completed)
            return;
        this.eventEmitter.emit('complete');
        this._completed = true;
    }
    public async increment() {
        this.value++;
    }
    public async decrement() {
        this.value--;
    }
    public async finish() {
        this.value = this.max;
    }
    public async reset() {
        this.eventEmitter.emit('reset');
        this._value = 0;
        this._status = '';
        this.max = 100;
        this._intervalStep = 0;
        this._completed = false;
    }
}

export enum LoadingSteps {
    fetch = 10,
    geomBuffer = 55,
    sceneCreation = 10,
    wireFrameCreation = 15,
    labelCreation = 10
}
